import React from 'react';

import styled from '@emotion/styled';
import { Switch } from '@material-ui/core';

const DisabledRippleSwitch = ({ ...props }) => <Switch {...props} disableRipple disableFocusRipple />;
const TogglePraise = styled(DisabledRippleSwitch)`
  width: 70px;
  height: 24px;
  padding: 0;
  display: flex;
  transform: scale(0.8);
  & .MuiSwitch-input {
    left: -10%;
  }
  & .Mui-checked {
    & .MuiSwitch-input {
      left: -190%;
    }
    left: 26px;
    & .MuiSwitch-thumb {
      color: white;
    }
    & + .MuiSwitch-track {
      background: #1565bc;
      opacity: 1;
      &::after {
        content: 'Praise';
        color: white;
        left: 8px;
        position: absolute;
      }
    }
  }
  & .MuiSwitch-switchBase {
    padding: 2px;
    color: #999999;
  }
  & .MuiSwitch-thumb {
    box-shadow: none;
    color: #999999;
    transform: scale(0.9);
  }
  & .MuiSwitch-track {
    opacity: 1;
    background: #ffffff;
    border-radius: 20px;
    border: 1px solid #999999;
    &::after {
      content: 'Praise';
      color: #666666;
      left: 26px;
      position: absolute;
    }
  }
`;

export { TogglePraise };
